import Vue from 'vue';
import Vuex from 'vuex';

import auth from '@/services/auth/store';
import alert from './modules/alert';
import layout from './modules/layout';
import houseFunds from './modules/housefunds';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  modules: {
    auth,
    alert,
    layout,
    houseFunds,
  },
});
